const COMBINING_MARKS_REGEX = /\p{M}/gu;
const WHITESPACE_REGEX = /\s+/g;
const MULTIPLE_HYPHENS_REGEX = /-+/g;
const NON_WORD_HYPHEN_REGEX = /[^\w-]+/g;

export const slugify = (text: string): string => {
  return text
    .toString()
    .normalize('NFD')
    .replace(COMBINING_MARKS_REGEX, '')
    .toLowerCase()
    .trim()
    .replace(WHITESPACE_REGEX, '-')
    .replace(MULTIPLE_HYPHENS_REGEX, '-')
    .replace(NON_WORD_HYPHEN_REGEX, '');
};
